import { jsx } from "react/jsx-runtime";
import RouteIcon from "@mui/icons-material/Route";
import { validateTidalLicense } from "../../base/index.js";
function Route(props) {
  return /* @__PURE__ */ jsx(
    RouteIcon,
    {
      "data-testid": "Route",
      ...props,
      "data-tidal": "TidalIcon",
      "data-tidal-icon": "Route",
      "data-tidal-icon-meta": "miscellaneous"
    }
  );
}
Route.tidalIconMeta = {
  categories: "miscellaneous",
  name: "Route"
};
validateTidalLicense();
export {
  Route
};
//# sourceMappingURL=Route.js.map
